import { useEffect, useMemo } from 'react';

export function useImgPreview(file?: File | Blob) {
    const url = useMemo(() => file && URL.createObjectURL(file), [file]);

    useEffect(
        () => () => {
            if (url) {
                URL.revokeObjectURL(url);
            }
        },
        [url],
    );

    return url;
}
